/**
 * Maps Fun.xyz chain IDs to MarketIcon symbol strings used for rendering chain logos.
 */
export const CHAIN_ICON_MAP: Record<string, string> = {
	'1': 'ETH', // Ethereum
	'10': 'OP', // Optimism
	'56': 'BNB', // BNB Smart Chain
	'137': 'POL', // Polygon
	'143': '1KMON', // Monad
	'999': 'HYPE', // HyperEVM
	'2741': 'ABSTRACT', // Abstract
	'8453': 'BASE', // Base
	'42161': 'ARB', // Arbitrum
	'3586256': 'LIT', // Lighter
	'5064014': 'ETHEREAL', // Ethereal
	'8253038': 'BTC', // Bitcoin
	'728126428': 'TRON', // Tron
	'1151111081099710': 'SOL', // Solana
};

export function getChainIconSymbol(chainId: string): string | undefined {
	return CHAIN_ICON_MAP[chainId];
}

/**
 * Maps Fun.xyz chain IDs to human-readable chain names.
 */
export const CHAIN_NAME_MAP: Record<string, string> = {
	'1': 'Ethereum',
	'10': 'Optimism',
	'56': 'BNB Smart Chain',
	'137': 'Polygon',
	'143': 'Monad',
	'999': 'HyperEVM',
	'2741': 'Abstract',
	'8453': 'Base',
	'42161': 'Arbitrum',
	'3586256': 'Lighter',
	'5064014': 'Ethereal',
	'8253038': 'Bitcoin',
	'728126428': 'Tron',
	'1151111081099710': 'Solana',
};

/**
 * Whitelist of allowed assets per chain for Fun.xyz deposit/withdrawal.
 * API results are filtered through this list.
 */
export const ALLOWED_ASSETS_BY_CHAIN: Record<string, Set<string>> = {
	'1': new Set([
		// Ethereum
		'WBTC',
		'PAXG',
		'BUSD',
		'USDe',
		'DAI',
		'AAVE',
		'USDP',
		'USDC',
		'ARB',
		'WETH',
		'ETH',
		'cbBTC',
		'USDT',
		'USDS',
	]),
	'10': new Set([
		// Optimism
		'USD₮0',
		'USDC',
		'WETH',
		'OP',
		'USDe',
		'USDT',
		'DAI',
		'ETH',
	]),
	'56': new Set([
		// BNB Smart Chain
		'DAI',
		'ETH',
		'USDT',
		'USDe',
		'BTCB',
		'USDC',
		'BNB',
		'WBNB',
		'BUSD',
	]),
	'137': new Set([
		// Polygon
		'USDC',
		'WETH',
		'POL',
		'USDT',
	]),
	'143': new Set([
		// Monad
		'WMON',
		'USDC',
		'MON',
		'USDT0',
	]),
	'999': new Set([
		// HyperEVM
		'WHYPE',
		'USDe',
		'hbHYPE',
		'UBTC',
		'USD₮0',
		'UETH',
		'HYPE',
		'USDC',
		'XAUt0',
		'kHYPE',
		'stHYPE',
	]),
	'2741': new Set([
		// Abstract
		'USDT',
		'WETH',
		'USDC',
		'ETH',
	]),
	'8453': new Set([
		// Base
		'uXRP',
		'WETH',
		'DAI',
		'USDe',
		'USDS',
		'USDC',
		'AERO',
		'ETH',
		'cbBTC',
		'USDbC',
		'USDT',
	]),
	'42161': new Set([
		// Arbitrum
		'WBTC',
		'USDe',
		'WETH',
		'ARB',
		'DAI',
		'ETH',
		'USDC',
		'USDT',
	]),
	'3586256': new Set([
		// Lighter
		'USDC',
	]),
	'5064014': new Set([
		// Ethereal
		'USDe',
	]),
	'8253038': new Set([
		// Bitcoin
		'BTC',
	]),
	'728126428': new Set([
		// Tron
		'USDT',
	]),
	'1151111081099710': new Set([
		// Solana
		'SOL',
		'TRUMP',
		'USDe',
		'USDC',
		'USDT',
		'CASH',
	]),
};

export function isAssetAllowed(chainId: string, symbol: string): boolean {
	const allowedSymbols = ALLOWED_ASSETS_BY_CHAIN[chainId];
	return allowedSymbols ? allowedSymbols.has(symbol) : false;
}
